export default __webpack_public_path__ + "075cd39a20ee4fa1f076dface7828841.png";